export default "__VITE_ASSET__B9uBV4RB__"